export type EntityTypeType = 'Organization' | 'Supplier';

export function defaultLoginRedirectPath(entityType: EntityTypeType) {
  return entityType === 'Supplier' ? '/works/supplier' : '/works';
}
